import baseService from '@/utils/http/axios'

//通用的从后台读取的字典
const dict = {
    state: {
        platform_list: [],
    },
    mutations: {
        SET_PLATFORM_LIST: (state, platform_list) => {
            state.platform_list = platform_list
        }
    },
    getters: {
        getPlatformList: (state) => state.platform_list
    },
    actions: {
        // 刷新数据，在加载用户信息的时候调用
        loadDict({ commit }) {
            let requeryParam = {
                url: '/admin/v1/loadCommDict',
                method: 'post',
                data: {}
            }
            baseService(requeryParam).then((res: any) => {
                commit('SET_PLATFORM_LIST', res.data.platform_list)
            }).catch(error => {
                console.log(error)
            }).finally(() => {
            })
        }
    },
    namespaced: true
}
export default dict
